export default "__VITE_ASSET__B5kH9fLF__"